module.exports = __webpack_public_path__ + "img/media-pic-5.e4e19cd1.svg";